<template>
  <span></span>
</template>

<script>
export default {
  created() {
    this.promptPassword();
  },
  methods: {
    promptPassword() {
      // const passwordEntered = prompt(
      //   "Password?",
      // );
      // if (passwordEntered === "groovygames") {
      //   this.$store.dispatch("logIn");
      // } else {
      //   this.promptPassword();
      // }
    }
  }
};
</script>